import axios from 'axios'

import GetToken from '../storage/Local/GetToken'

const client = axios.create({
    baseURL: 'https://mss.rasti.ca/api',
    timeout: 30000,
    headers: {
        Accept: 'application/json',
    },
})

export const crmClient = axios.create({
    baseURL: 'https://crm.rasti.ca/api',
    timeout: 30000,
    headers: {
        Accept: 'application/json',
    },
})

client.interceptors.request.use(
    (config) => {
        const token = GetToken()
        if (token && !config.headers['X-No-Bearer']) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => Promise.reject(error)
)

export default client
